import { render, staticRenderFns } from "./Logar.vue?vue&type=template&id=315c4de4&"
import script from "./Logar.vue?vue&type=script&lang=ts&"
export * from "./Logar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Logar.vue"
export default component.exports